module.exports = [
  {
    value: 'yes',
    label: 'MEDICATIONS.V2.FORM.OPTION.ADR_LESSENED.YES',
    active: true,
  },
  {
    value: 'no',
    label: 'MEDICATIONS.V2.FORM.OPTION.ADR_LESSENED.NO',
    active: true,
  },
  {
    value: 'unknown',
    label: 'MEDICATIONS.V2.FORM.OPTION.ADR_LESSENED.UNKNOWN',
    active: true,
  },
  {
    value: 'na',
    label: 'MEDICATIONS.V2.FORM.OPTION.ADR_LESSENED.NA',
    active: true,
  },
];
